module.exports = __webpack_public_path__ + "static/img/class_24.036093d5.jpg";